
@if(selectedNamedFilter){
    <div class="savedFilterSelector">
        <div class="btn savedFilterButton me-3" 
             [innerHTML]="selectedNamedFilter.nameForSelector" 
             (click)="displayList = !displayList"></div>
        @if(displayList){
            <ul class="savedFilterList" [ngClass]="{'showCreateLink': createLink}">
                @for(namedFilter of filters; track namedFilter.id){
                    <li [innerHTML]="namedFilter.nameForSelector" (click)="change(namedFilter)"></li>
                }
            </ul>
            <div class="savedFilterBackground" (click)="displayList = false"></div>
        }
    </div>
}